export const YOUTUBE = 0
export const RUTUBE = 1
export const VK = 2